import "./banner.css";
import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../../router/router";
import { useEffect } from "react";
const Banner = () => {
  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, []);

  const navigate = useNavigate();
  return (
    <div className="relative 2xl:h-full xl:h-[700px] lg:h-[600px] md:h-[600px] sm:h-[500px] h-[440px] overflow-hidden">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="https://vizybilitystorage.blob.core.windows.net/videos/DMSDb_ALPHAOMEGA/WebApp/TuataraUSABanner.9348ec7ef8058df4b5cf.mp4?sp=r&st=2024-11-26T16:01:07Z&se=2028-12-31T00:01:07Z&spr=https&sv=2022-11-02&sr=b&sig=jY1JkjWRw0a4lXJ25ZeKmaASjx4WnVS%2Bmt2My%2FIj0eo%3D"
        loop
        muted
        playsInline
        preload="auto"
        onCanPlay={(e) => e.target.play()}
      ></video>

      {/* <div className="absolute top-0 left-0 w-full h-auto object-scale-down">
        <img src={HeroImage} alt="" />
      </div> */}

      <div className="relative z-1 flex justify-between  flex-col items-center justify-center h-[75svh] text-center text-white">
        {/* <div
          className="text-[#F2F2F2] banner-text mt-[49px] 
        2xl:mb-[313px] xl:mb-[234px] lg:mb-[171px] md:mb-[171px] sm:mb-[161px] mb-[172px]
         2xl:text-[40px] xl:text-[30px] lg:text-[25px] md:text-[20px] sm:text-[17px] text-[15px]"
        >
          BUILT FOR THE JOURNEY <br />
          POWERED FOR THE ADVENTURE
        </div> */}

        {/* <div className="text-center mb-[135px]">
          <button
            className="bg-[#5B792E] text-[#fff] font-[Roboto] lg:text-[30px] sm:text-[25px] text-[20px] font-extrabold lg:py-[20px] sm:py-[16px] py-[10px] lg:px-[57px] sm:px-[47px] px-[37px]"
            style={{ boxShadow: "0px 8px 4px 0px #00000066" }}
            onClick={() => navigate(RouterPaths.UtilityVehicles)}
          >
            EXPLORE VEHICLES
          </button>
        </div> */}
      </div>
    </div>
  );
};
export default Banner;
